import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ChartsModule } from "ng2-charts";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { MatCardModule } from "@angular/material/card";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MaterialModule } from "@app/material/material.module";
import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { ColorSwitcherComponent } from "./color-switcher/color-switcher.component";
import { TokenInterceptor } from "@app/core/interceptors/token.interceptor";
import { ErrorInterceptor } from "@app/core/interceptors/error.interceptor";
import { MarkAsteriskDirective } from "./directives/mark-asterisk.directive";
import { LoaderComponent } from "./loader/loader/loader.component";


@NgModule({
  exports: [
    CommonModule,
    FooterComponent,
    LoaderComponent,
    NavbarComponent,
    SidebarComponent,
    ColorSwitcherComponent,
    NgbModule,
    NgbModule,
    ChartsModule,
    NgxDatatableModule,
    NgxChartsModule,
    MatDatepickerModule,
    MatTableModule,
    MatCardModule,
    MatStepperModule,
    MatIconModule,
    MatSnackBarModule,
  ],
  imports: [
    RouterModule,
    CommonModule,
    PerfectScrollbarModule,
    NgbModule,
    ChartsModule,
    NgxDatatableModule,
    NgxChartsModule,
    MatDatepickerModule,
    MatTableModule,
    MatCardModule,
    MatStepperModule,
    MatIconModule,
    MatSnackBarModule,
    MaterialModule
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ColorSwitcherComponent,
    MarkAsteriskDirective,
    LoaderComponent,
  ],
  providers: [TokenInterceptor, ErrorInterceptor],
})
export class SharedModule {}
